'use client';

import Image from "next/image";
import { useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { useTranslations } from "next-intl";

export default function AdvantagesSection() {
  const t = useTranslations('advantages_section');
  const [activeTabId, setActiveTabId] = useState<number | null>(1);

  const features = [
    {
      id: 1,
      title: t('oriental_medicine_experience.title'),
      image: "/images/2.png",
      description: t('oriental_medicine_experience.description'),
    },
    {
      id: 2,
      title: t('trusted_reputation.title'),
      image: "/images/4.png",
      description: t('trusted_reputation.description'),
    },
    {
      id: 3,
      title: t('holistic_approach.title'),
      image: "/images/1.png",
      description: t('holistic_approach.description'),
    },
    {
      id: 4,
      title: t('stable_quality.title'),
      image: "/images/5.png",
      description: t('stable_quality.description'),
    },
  ];

  const [activeImage, setActiveImage] = useState(features[0].image);

  return (
    <div className="container mx-auto">
      <div className="mb-12 flex w-full items-start justify-between gap-12">
        <div className="w-full md:w-1/2">
          <Accordion type="single" className="w-full" defaultValue="item-1">
            {features.map((tab) => (
              <AccordionItem
                key={tab.id}
                value={`item-${tab.id}`}
                className="transition-opacity hover:opacity-80"
              >
                <AccordionTrigger
                  onClick={() => {
                    setActiveImage(tab.image);
                    setActiveTabId(tab.id);
                  }}
                  className="no-underline! cursor-pointer py-5 transition"
                >
                  <h4
                    className={`text-lg font-semibold ${tab.id === activeTabId ? "text-foreground" : "text-muted-foreground"}`}
                  >
                    {tab.title}
                  </h4>
                </AccordionTrigger>
                <AccordionContent>
                  <p className="text-muted-foreground text-sm">
                    {tab.description}
                  </p>
                  <div className="mt-4 md:hidden">
                    <div className="relative aspect-square w-full overflow-hidden rounded-md bg-muted">
                      <Image
                        src={tab.image}
                        alt={tab.title}
                        fill
                        sizes="100vw"
                        className="object-cover"
                      />
                    </div>
                  </div>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
        <div className="relative m-auto hidden w-1/2 md:block">
          <div className="relative aspect-square w-full overflow-hidden rounded-xl bg-muted">
            <Image
              src={activeImage}
              alt="Feature preview"
              fill
              sizes="(min-width: 768px) 50vw, 100vw"
              className="object-cover"
              priority={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
